import * as tslib_1 from "tslib";
import { ViewContainerRef } from '@angular/core';
import { PDAuthService } from 'pdauth';
import { InputConverter } from '../../inputConverter';
import { BaseComponent } from '../base.component';
var AuthComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AuthComponent, _super);
    function AuthComponent(vcr, pdauth, authService) {
        var _this = _super.call(this, vcr) || this;
        _this.pdauth = pdauth;
        _this.authService = authService;
        _this.showUser = true;
        _this.showEmail = true;
        _this.prefix = 'User ';
        _this.forceLogin = false;
        _this.autoLogin = false;
        _this.initialized = false;
        _this.login = function () {
            _this.pdauth.authenticateUser();
        };
        _this.logout = function () {
            _this.pdauth.logOut();
        };
        return _this;
    }
    Object.defineProperty(AuthComponent.prototype, "authUrl", {
        get: function () {
            return this._authUrl;
        },
        set: function (val) {
            this._authUrl = val;
            this.initialize();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthComponent.prototype, "isLoggedIn", {
        get: function () {
            return this.pdauth.isLoggedIn();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthComponent.prototype, "user", {
        get: function () {
            return this.pdauth.getLoggedInUser();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthComponent.prototype, "permissions", {
        get: function () {
            return this.pdauth.getLoggedInUserPermissions();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthComponent.prototype, "isOnInternalNetwork", {
        get: function () {
            return this.pdauth.getIsOnInternalNetwork();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthComponent.prototype, "PDAuthService", {
        get: function () {
            return this.pdauth;
        },
        enumerable: true,
        configurable: true
    });
    AuthComponent.prototype.initialize = function () {
        var _this = this;
        if (!this.initialized) {
            this.initialized = true;
            this.pdauth.initialize(this.authUrl, this.appName);
            this.authService.GetCurrentUser().subscribe(function (user) {
                if (_this.showEmail) {
                    _this.userString = user ? user.emailAddress : 'None';
                }
                else {
                    _this.userString = user ? user.fullName : 'None';
                }
            });
            if (this.forceLogin) {
                this.pdauth.enableForcedLogin();
            }
            if (this.autoLogin) {
                this.pdauth.logInAutomatically();
            }
            this.isReady();
        }
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], AuthComponent.prototype, "showUser", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], AuthComponent.prototype, "showEmail", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], AuthComponent.prototype, "forceLogin", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], AuthComponent.prototype, "autoLogin", void 0);
    return AuthComponent;
}(BaseComponent));
export { AuthComponent };
